import { ArrowForwardOutlined } from '@lichtblick/icons';
import { styled } from '@lichtblick/styled';
import { Colors, Spacing } from '@lichtblick/theme';

export const SkeletonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Spacing.Xs};
`;

export const Container = styled.tr`
  align-items: stretch;
  display: flex;
  height: auto;
  width: 100%;
`;

export const WorkOrderItem = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  flex-grow: 0;
  gap: ${Spacing.Xxs};
  padding: ${Spacing.Xs};
  width: 20rem;
`;

export const AppointmentWrapper = styled.td`
  border-bottom: ${`1px solid ${Colors.blue['20']}`};
  border-top: ${`1px solid ${Colors.blue['20']}`};
`;

export const TDWrapper = styled.td<{ $hasDivider?: boolean }>`
  position: relative;
  align-items: center;
  display: flex;
  border-bottom: ${`1px solid ${Colors.blue['20']}`};
  border-top: ${`1px solid ${Colors.blue['20']}`};

  ${({ $hasDivider }) =>
    $hasDivider &&
    `
      &::after {
        content: '';
        position: absolute;
        top: 1rem;
        bottom: 1rem;
        right: 0;
        width: 1px; 
        background-color: ${Colors.blue[20]};
      }
    `}
`;

export const Divider = styled.div`
  background-color: ${Colors.blue['20']};
  height: 60%;
  width: 1px;
`;

export const ArrowForwardOutlinedIcon = styled(ArrowForwardOutlined)`
  color: ${Colors.gray['50']};
  height: 1rem;
  margin-right: ${Spacing.Xs};
  width: 1rem;
  cursor: pointer;
`;
